"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoutingType = exports.RoutingBotSkillFallbackActionType = void 0;
var RoutingBotSkillFallbackActionType;
(function (RoutingBotSkillFallbackActionType) {
  RoutingBotSkillFallbackActionType["DROP_CALENDAR"] = "DROP_CALENDAR";
  RoutingBotSkillFallbackActionType["REROUTE_GLOBAL"] = "REROUTE_GLOBAL";
})(RoutingBotSkillFallbackActionType = exports.RoutingBotSkillFallbackActionType || (exports.RoutingBotSkillFallbackActionType = {}));
var RoutingType;
(function (RoutingType) {
  RoutingType["GLOBAL"] = "GLOBAL";
  RoutingType["SINGLE"] = "SINGLE";
  RoutingType["GROUP"] = "GROUP";
  RoutingType["TEAM"] = "TEAM";
  RoutingType["DIRECT"] = "DIRECT";
  RoutingType["ABM"] = "ABM";
  RoutingType["LEANDATA"] = "LEANDATA";
})(RoutingType = exports.RoutingType || (exports.RoutingType = {}));